
export default [
  {
   
    path :'/register',
    name: 'register',
    meta: {
      redirectIfLoggedIn: true
    },
    component: () => import('@/views/user/Register')

  },
  {
    path :'/login',
    name: 'login',
    meta: {
      redirectIfLoggedIn: true
    },
    component: () => import('@/views/user/Login')
  },
  {
    path: '/error-404',
    name: 'page-error-404',
    component: () => import('@/views/Error404.vue')
  }

        
]
